/**
 * Tela 7 — Atendimento em Grupo?
 * Estrutura de layout IDÊNTICA ao Step1Name (que funciona): <Box> simples,
 * minHeight:'100%', flex column centralizado. Sem <Container>, sem height:'100%'.
 */

import { Box, Button, Typography } from '@mui/material';
import { getWelcomeText } from '../../../utils/welcomeText';
import { wlog } from '../../../utils/welcomeDebug';

export function Step7Group({ wizard, goNext }) {
  wlog('Step7Group', 'RENDER — INÍCIO', {
    templateId: wizard.template?.id || 'NENHUM',
    userName: wizard.state?.userName,
    servicesLen: wizard.state?.services?.length,
  });

  const template = wizard.template;
  const firstName = wizard.state?.userName?.split(' ')[0]?.trim() || '';

  const question =
    getWelcomeText(template, 'groupQuestion', { firstName }) ||
    'Algum serviço você atende com mais de um cliente ao mesmo tempo?';
  const yesLabel =
    getWelcomeText(template, 'groupYesLabel', { firstName }) ||
    '👥 Sim, tenho turmas';
  const noLabel =
    getWelcomeText(template, 'groupNoLabel', { firstName }) ||
    '🙋 Não, atendimento individual';

  const advance = goNext || wizard.goNext;

  const handleYes = () => {
    wlog('Step7Group', 'handleYes()');
    wizard.setHasGroups(true);
    advance();
  };

  const handleNo = () => {
    wlog('Step7Group', 'handleNo()');
    wizard.setHasGroups(false);
    (wizard.state?.services || []).forEach((service) => {
      wizard.setGroupSize(service.id, 1);
    });
    advance();
  };

  wlog('Step7Group', 'RENDER — VOU RETORNAR JSX', { question, yesLabel, noLabel });

  return (
    <Box
      component="section"
      data-step="groupQuestion"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px 40px',
        minHeight: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ maxWidth: '500px', width: '100%', textAlign: 'center' }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 600, marginBottom: '32px', color: 'text.primary' }}
        >
          {question}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Button
            variant="contained"
            size="large"
            onClick={handleYes}
            sx={{ textTransform: 'none', fontSize: '16px', fontWeight: 600, paddingY: '14px' }}
          >
            {yesLabel}
          </Button>

          <Button
            variant="outlined"
            size="large"
            onClick={handleNo}
            sx={{ textTransform: 'none', fontSize: '16px', fontWeight: 600, paddingY: '14px' }}
          >
            {noLabel}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default Step7Group;
